export default Object.freeze({
	ASSET_MANAGER_MANAGE: 'AssetManagerManage',
	COMPANY_POLICIES_MANAGE: 'CompanyPoliciesManage',
	POSITION_TEMPLATES_MANAGE: 'PositionTemplatesManage'
});
